import { memo, useEffect, useRef } from 'react'
import { useYMaps } from '@pbe/react-yandex-maps'
import { DEFAULT_CENTER, MapProps } from 'components/Map'
import { useIsMobile } from 'hooks/media'

type TerminalMapProps = MapProps & {
  className?: string
  name?: string
}

const TerminalMap = ({ className, name, height, width, center, zoom }: TerminalMapProps) => {
  const isMobile = useIsMobile()
  const mapRef = useRef(null)
  const ymaps = useYMaps(['Map', 'Placemark'])

  useEffect(() => {
    if (!ymaps || !mapRef.current) {
      return
    }

    const map = new ymaps.Map(mapRef.current, {
      center: center || DEFAULT_CENTER,
      zoom
    })
    const placeMark = new ymaps.Placemark(map.getCenter(), { iconCaption: name })

    map.geoObjects.add(placeMark)

    return () => {
      mapRef.current = null
    }
  }, [center, name, ymaps, zoom])

  return (
    <div ref={mapRef} className={className} style={{ width: width || '100%', height: isMobile ? '100%' : height }} />
  )
}

export default memo(TerminalMap)
